import get from 'lodash/get';
import {campaigns, accounts} from '../../../services/voxfeed';
import {buildAPIRequest} from '../helpers';

const FETCH_CAMPAIGN_ACTIVITY_STATS = 'voxfeed/shared/voxfeed/campaigns/FETCH_CAMPAIGN_ACTIVITY_STATS';
const FETCH_ADVERTISER_ACTIVITY_STATS = 'voxfeed/shared/voxfeed/campaigns/FETCH_ADVERTISER_ACTIVITY_STATS';
const GET_CAMPAIGN_EXPECTED_REACH = 'voxfeed/shared/voxfeed/campaigns/GET_CAMPAIGN_EXPECTED_REACH';
const FETCH_INFLUENCER_DEMOGRAPHICS =
  'voxfeed/shared/voxfeed/campaigns/FETCH_INFLUENCER_DEMOGRAPHICS';
const FETCH_CAMPAIGN_REACHED_AUDIENCE =
  'voxfeed/shared/voxfeed/campaigns/FETCH_CAMPAIGN_REACHED_AUDIENCE';

const initialState = {campaigns: {}, advertisers: {}};

export default function reducer(state = initialState, {type, payload}) {
  switch (type) {
    case FETCH_CAMPAIGN_ACTIVITY_STATS: {
      return {
        ...state,
        campaigns: {
          [payload.campaignId]: payload.data
        }
      };
    }

    case FETCH_ADVERTISER_ACTIVITY_STATS: {
      return {
        ...state,
        advertisers: {
          [payload.accountId]: payload.data
        }
      };
    }

    case GET_CAMPAIGN_EXPECTED_REACH: {
      const expectedReach = {expectedReach: payload.data};
      const campaignStat = {
        [payload.campaignId]: {
          ...get(state, `campaigns.${payload.campaignId}`),
          ...expectedReach
        }
      };

      return {
        ...state,
        campaigns: {
          ...state.campaigns,
          ...campaignStat
        }
      };
    }

    case FETCH_INFLUENCER_DEMOGRAPHICS: {
      return {
        ...state,
        campaigns: {
          ...state.campaigns,
          [payload.campaignId]: {
            ...get(state, `campaigns.${payload.campaignId}`),
            influencersDemographics: payload.data
          }
        }
      };
    }

    case FETCH_CAMPAIGN_REACHED_AUDIENCE: {
      return {
        ...state,
        campaigns: {
          ...state.campaigns,
          [payload.campaignId]: {
            ...get(state, `campaigns.${payload.campaignId}`),
            reachedAudience: payload.data
          }
        }
      };
    }

    default:
      return state;
  }
}

export const getCampaignActivityStatistics = campaignId => buildAPIRequest({
  id: 'getCampaignActivityStatistics',
  method: campaigns.getActivityStatisticsByCampaignId,
  params: campaignId,
  callback: ({dispatch, data}) => {
    dispatch({
      type: FETCH_CAMPAIGN_ACTIVITY_STATS,
      payload: {campaignId, data}
    });
  }
});

export const getCampaignInfluencerDemographics = campaignId => buildAPIRequest({
  id: 'getInfluencerDemographics',
  method: campaigns.getInfluencerDemographics,
  params: campaignId,
  callback: ({dispatch, data}) => {
    dispatch({
      type: FETCH_INFLUENCER_DEMOGRAPHICS,
      payload: {campaignId, data}
    });
  }
});

export const getCampaignExpectedReach = (campaign, countries) => buildAPIRequest({
  id: 'getExpectedReach',
  method: campaigns.calculateExpectedReach,
  params: {campaign, countries},
  callback: ({dispatch, data}) => {
    dispatch({
      type: GET_CAMPAIGN_EXPECTED_REACH,
      payload: {data, campaignId: campaign.id}
    });
  }
});

export const getAdvertiserActivityStatistics = accountId => buildAPIRequest({
  id: 'getInfluencerDemographics',
  params: accountId,
  method: accounts.getActivityStatisticsByAdvertiserId,
  callback: ({dispatch, data}) => {
    dispatch({
      type: FETCH_ADVERTISER_ACTIVITY_STATS,
      payload: {accountId, data}
    });
  }
});

export const fetchCampaignReachedAudience = campaignId => buildAPIRequest({
  id: `fetchCampaignReachedAudience_${campaignId}`,
  method: campaigns.fetchCampaignReachedAudience,
  params: campaignId,
  callback: ({dispatch, data}) => {
    dispatch({
      type: FETCH_CAMPAIGN_REACHED_AUDIENCE,
      payload: {campaignId, data}
    });
  }
});

export const constants = {
  FETCH_CAMPAIGN_ACTIVITY_STATS,
  FETCH_ADVERTISER_ACTIVITY_STATS,
  GET_CAMPAIGN_EXPECTED_REACH,
  FETCH_INFLUENCER_DEMOGRAPHICS,
  FETCH_CAMPAIGN_REACHED_AUDIENCE
};
